export default "__VITE_ASSET__BeC$L_Kq__"